import { Link } from 'react-router-dom';
import { api } from '../api';
import { useAsync, useToast } from '../hooks';
import { StatusBadge } from '../components/StatusBadge';

export function SitesPage() {
  const { data, error, loading, reload } = useAsync(() => api.sites(), []);
  const { toast, show } = useToast();
  return (
    <div>
      <div className="topbar">
        <div>
          <h1>All sites</h1>
          <p className="muted small">Every scanned website and its Springboard. Pick one from the selector on the left, or add a new one.</p>
        </div>
        <Link className="btn primary" to="/sites/new">Add a site</Link>
      </div>

      {error && <p className="badge bad">{error}</p>}
      {loading && <p className="muted">Loading…</p>}
      {data && data.sites.length === 0 && <div className="empty">No sites yet. Add one to start.</div>}
      {data && data.sites.length > 0 && (
        <div className="card" style={{ padding: 0 }}>
          <table>
            <thead>
              <tr>
                <th>Site</th>
                <th>Status</th>
                <th>Snippet</th>
                <th>Published</th>
                <th>Draft</th>
                <th>Site key</th>
                <th>Created</th>
              </tr>
            </thead>
            <tbody>
              {data.sites.map((s) => (
                <tr key={s.siteId}>
                  <td>
                    <Link to={`/sites/${s.siteId}`} style={{ color: 'var(--accent)' }}>
                      {s.brandName || s.domain}
                    </Link>
                    <div className="small muted">{s.primaryUrl}</div>
                  </td>
                  <td>
                    <StatusBadge status={s.status} />
                  </td>
                  <td>{s.install && Date.now() - Date.parse(s.install.lastSeenAt) < 7 * 86400e3 ? <span className="badge ok" title={s.install.origin ?? ''}>installed</span> : <span className="badge warn">not detected</span>}</td>
                  <td>{s.publishedConfigVersion ? `v${s.publishedConfigVersion}` : '—'}</td>
                  <td>{s.draftConfigVersion ? <span className="badge warn">v{s.draftConfigVersion}</span> : '—'}</td>
                  <td className="mono">{s.siteKey}</td>
                  <td className="small muted">{new Date(s.createdAt).toLocaleString()}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}
      {toast && <div className={`toast${toast.err ? ' err' : ''}`}>{toast.text}</div>}
    </div>
  );
}
